import { FC, useContext } from "react"
import { LoaderContext } from "../../context/loaderContext";
import {AuthContext} from "../../context/authContext";
const HubLoader: FC = (): JSX.Element => {
  const { isVisible } = useContext(LoaderContext);
  const { isManufacturer } = useContext(AuthContext);

  return (
      <>
        {isManufacturer ? (
            <div className={`spinner-overlay ${isVisible ? 'd-flex' : 'd-none'}`}>
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
        ): (
            <div
                className={`progress w-100 loader ${isVisible ? 'd-flex' : 'd-none'}`}
                role="progressbar"
                aria-valuenow={100}
                aria-valuemin={0}
                aria-valuemax={100}
            >
              <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  style={{width: '100%'}}
              ></div>
            </div>
        )}
      </>
  );
};

export default HubLoader;
